import React from 'react';
import { useLocation } from 'react-router-dom';

interface Props {
  children: React.ReactNode;
}

// 全局页面过渡：移除动画，直接渲染内容
export const PageTransition: React.FC<Props> = ({ children }) => {
  const location = useLocation();
  
  // 使用 pathname 作为 key 确保路由切换时重新渲染
  const presenceKey = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;

  return (
    <div key={presenceKey} className="min-h-screen">
      {children}
    </div>
  );
};

export default PageTransition;
